export const VendorImage = ({ img }: { img?: string }) => {
  return (
    <img
      src={img}
      className="block object-cover w-[40px] h-[40px] min-w-[40px] min-h-[40px] max-w-[40px] max-h-[40px] rounded-full overflow-hidden"
      alt="Creator Logo"
    />
  )
}
